<div class="access-denied-container">
    <div class="illustration-container">
        <!-- Replace this SVG with the actual image path if available -->
        <h4 class="illustration-title">UNAUTHORIZED ACCESS</h4>
        <img src="assets/access-denied.png" alt="Restricted Area" class="img-denied" />
    </div>

    <h1 class="main-title">Access Denied</h1>

    <p class="description">
        You don't have the necessary permits to<br>access this area. Please contact your<br>supervisor if you believe this is a mistake.
    </p>

    <div class="action-buttons">
        <button class="btn btn-dashboard" (click)="goToDashboard()">
            Back to Dashboard
        </button>
        <button class="btn btn-outline" (click)="requestAccess()">
            Request Access
        </button>
    </div>

    <div class="quick-links-section">
        <h6 class="section-title">QUICK LINKS</h6>
        <div class="links-wrapper">
            <button class="btn-sitemap" (click)="goToDashboard()">
                Site Map
            </button>
        </div>
    </div>
</div>
